import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

const httpOptionData = {
  headers: new HttpHeaders({
   // 'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
}

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  url = environment.baseUrl+ '/api/Empresa';

  constructor(private http: HttpClient) {}

  getEmpresas(page: number, numReg: number,searchString:string): Observable<any> {
    const body = { page, numReg,searchString };
    return this.http.post<any>(this.url + '/GetEmpresas', body, httpOption);
  }

  getEmpresasDropdown(): Observable<any> {
    // const body = { page, numReg, searchString };
     return this.http.post<any>(this.url + '/GetEmpresasDropdown', {}, httpOption);
   }

   addEmpresa(obj:any): Observable<boolean> {
   // const body = { page, numReg, searchString };
    return this.http.post<boolean>(this.url + '/AddEmpresa', obj, httpOption);
  }

  getEmpresa(id:string): Observable<any> {
    // const body = { page, numReg, searchString };
     return this.http.post<any>(this.url + '/GetEmpresa', {id}, httpOption);
   }

   editEmpresa(obj:any): Observable<boolean> {
    // const body = { page, numReg, searchString };
     return this.http.post<boolean>(this.url + '/EditEmpresa', obj, httpOption);
   }

   getDatosEmpresa(): Observable<any> {
    // const body = { page, numReg, searchString };
     return this.http.post<any>(this.url + '/GetDatosEmpresa', {}, httpOption);
   }

   actualizarDatosEmpresa(obj:any): Observable<boolean> {
    // const body = { page, numReg, searchString };
     return this.http.post<boolean>(this.url + '/ActualizarDatosEmpresa', obj, httpOption);
   }

   actualizarImagen(fileToUpload:any): Observable<boolean> {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http.post<boolean>(this.url + '/ActualizarImagen', formData, httpOptionData);
  }
  
  editFechaServicioEmpresa(obj:any): Observable<boolean> {
    // const body = { page, numReg, searchString };
     return this.http.post<boolean>(this.url + '/EditFechaServicioEmpresa', obj, httpOption);
   }

   cambiarSaldo(obj:any): Observable<number> {
    // const body = { page, numReg, searchString };
     return this.http.post<number>(this.url + '/CambiarSaldo', obj, httpOption);
   }

   getSaldoEmpresa(): Observable<number> {
    // const body = { page, numReg, searchString };
     return this.http.post<number>(this.url + '/GetSaldoEmpresa', {}, httpOption);
   }

   getSaldoEmpresaAdmin(id:string): Observable<number> {
    // const body = { page, numReg, searchString };
     return this.http.post<number>(this.url + '/GetSaldoEmpresaAdmin', {id}, httpOption);
   }

   

}
